import { Component } from "react";
import AppContext from "../../contexts/AppContext";

class GoogleLocation extends Component {
    state = {
        gmapsLoaded: false
    };

    initMap = () => {
        this.context.state.setGmapsLoaded(true);
    };

    componentDidMount() {
        window.initMap = this.initMap;
        const gmapScriptEl = document.createElement(`script`);
        gmapScriptEl.defer = true;
        gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAzBD9_ThJyZrFU9gUR6r__Z-9BeSKpWd4&libraries=places&callback=initMap`;
        document
            .querySelector(`body`)
            .insertAdjacentElement(`beforeend`, gmapScriptEl);
    }

    render() {
        return null;
    }
}

GoogleLocation.contextType = AppContext;
export default GoogleLocation;



// WEBPACK FOOTER //
// ./src/components/auth/GoogleLocation.js